import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { ButtonGroupSelector, ButtonLoader, Input } from "../common/form";
import FormDrawer from "components/__new/common/form-drawer";
import CustomSwitch from "../common/form/CustomSwitch";
import useLoginInfo from "hooks/useLoginInfo";
import ModalAlert from "../common/ModalAlert";
import validate from "utils/validate";
import { toast } from "react-toastify";
import successGif from "assets/images/icons/success-green-2.gif";
import maskEmailAddress from "utils/maskData";
import * as walletAction from "store/entities/wallet/action";


const GenerateAccountStatement = (props) => {
    const { isOpen, setIsOpen } = props;
    const dispatch = useDispatch();
    const { userInfo } = useLoginInfo();
    const { accountStatementLoading, accountStatement, accountDetails } = useSelector((s) => s.entities.wallet);
    const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
    const [useCustomEmail, setUseCustomEmail] = useState(false);
    const [form, setForm] = useState({
        startDate: "",
        endDate: "",
        email: userInfo?.employer?.email,
    })
    const [exportOptions, setExportOptions] = useState([
        {
            label: "PDF",
            value: "pdf",
            selected: true,
        },
        {
            label: "Excel",
            value: "excel",
            selected: false,
        },
    ])
    
    const updateEmail = (e) => {
        if (e === true){
            setUseCustomEmail(true);
            setForm({...form, email: ""});
        }
        else{
            setUseCustomEmail(false);
            setForm({...form, email: userInfo?.employer?.email});
        }
    }
    
    const updateExportOptions = (e) => {
        let data = exportOptions.map((option) => {
            return {
                ...option,
                selected: option.value === e,
            }
        });
        setExportOptions(data);
    }
    
    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            if (moment(form.startDate) <= moment(form.endDate)){
                const type = exportOptions.filter((option) => option.selected === true)[0];
                let params = {
                    startDate: form.startDate,
                    endDate: form.endDate,
                    type: type.value,
                    email: form?.email
                }
                if (useCustomEmail === true){
                    params = {
                        ...params,
                        email: form?.email,
                    }
                }
                const walletId = accountDetails?.data?.walletId;
                dispatch(walletAction.generateAccountStatement(params, walletId));
            }
            else{
                toast.error("End date cannot be before the start date");
            }
        }
    }
    
    useEffect(() => {
        if (accountStatement?.status === "success"){
            setIsOpenModalAlert(true);
        }
    }, [accountStatement])
    
    return (
        <>
            <ModalAlert
                successImg={successGif}
                successText={<>Your statement has been generated and sent to {maskEmailAddress(form.email)}</>}
                // dismissText="Close"
                isOpenModalAlert={isOpenModalAlert}
                setIsOpenModalAlert={setIsOpenModalAlert}
                button1={{
                    "text": "Close",
                    "class": "btn btn-lg btn-ep-primary btn-block",
                    "click": () => {setIsOpen(false); setIsOpenModalAlert(false)},
                }}
            />
        
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Generate Statement"
                        description="Get your account statement over a period of time"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    
                    <hr className="w-full h-px mt-2 bg-[#E2E4E8] border-none" />
                    
                    <form onSubmit={submitForm} className="mt-4">
                        <div className="p-1 mb-4 bg-ep-gray-200 rounded-lg">
                            <ButtonGroupSelector
                                selectOptions={exportOptions}
                                onValueChange={(e) => updateExportOptions(e)}
                                design="slide-tab-toggle"
                            />
                        </div>
                        <div>
                            <Input type="text" label="Account" disabled={true} required={false} value={accountDetails?.data?.accountName} onChange={(e) => setForm({...form, accountName: e.target.value})} inputClass="mt-1" />
                        </div>
                        <div className="grid grid-cols-2 gap-6">
                            <Input type="date" label="From" placeholder="Select Date" min={moment().subtract(1,"year").format("YYYY-MM-DD")} max={moment().format("YYYY-MM-DD")} required={true} value={form.startDate} onChange={(e) => setForm({...form, startDate: e.target.value})} />
                            <Input type="date" label="To" placeholder="Select Date" min={moment().subtract(1,"year").format("YYYY-MM-DD")} max={moment().format("YYYY-MM-DD")} required={true} value={form.endDate} onChange={(e) => setForm({...form, endDate: e.target.value})} />
                        </div>
                        
                        <div className="relative">
                            <div className="absolute top-0 right-0 flex">
                                <CustomSwitch
                                    active={useCustomEmail}
                                    activeText="Use a different email"
                                    inactiveText="Use a different email"
                                    onChange={(e) => updateEmail(e)}
                                />
                            </div>
                            <Input type="email" label="Email Address" disabled={useCustomEmail === false} required={true} value={form?.email} onChange={(e) => setForm({...form, email: e.target.value})} inputClass="mt-1" hideValidationMessage={useCustomEmail === false} />
                        </div>
                        
                        <div className="mt-10 flex justify-end space-x-4">
                            <button type="button" onClick={() => setIsOpen(false)} className="btn btn-lg btn-transparent-primary">
                                Cancel
                            </button>
                            <ButtonLoader type="submit" loading={accountStatementLoading} className="btn btn-lg btn-ep-primary">
                                Generate Statement
                            </ButtonLoader>
                        </div>
                    </form>
                </div>
            </FormDrawer>
        </>
    )
}


export default GenerateAccountStatement;